export function validateResponse(resultCd, resultMsg) {
  if (resultCd !== '0000') {
    throw new Error(resultMsg, {
      cause: resultCd,
    });
  }
}
